export const contactsData = {
    email: 'ekosetiaji929@gmail.com',
    phone: '0895600394345',
    address: 'Karawang',

    sheetAPI: ''
}